"use client";

import { useTranslations } from "next-intl";

export const NoDataForTheme = ({ message, description }) => {
  const t = useTranslations()

  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <>
      <main className="grid min-h-full place-items-center bg-white px-6 py-15  lg:px-8">
        <div className="text-center">
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            {message}{" "}
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            {description}{" "}
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <button
              onClick={() => handleRefresh()}
              className="rounded-md bg-mainLightPurple min-w-22.5 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-mainLightPurpleHover"
            >
              {t("refreshPage")}
            </button>
          </div>
        </div>
      </main>
    </>
  );
};
